import { Fragment, useEffect, useState } from 'react';
import chargerStationLogo from '../../assets/charger-station-logo.png';
import carIcon from '../../assets/car-icon.png';
import autonomyIcon from '../../assets/autonomy-icon.png';
import plateIcon from '../../assets/plate-icon.png';
import calenderIcon from '../../assets/calender-icon.png';
import powerIcon from '../../assets/switch-button-power-icon.png'
import alertIcon from '../../assets/alert-icon.png';

import { Footer } from './components/Footer/Footer';
import moment from 'moment';
import api from './../../axios/axiosConfig';
import { HeaderViewer } from './../../components/header-viewer/HeaderViewer';
import './RechargePriority.css';
import {FleetVehicle, RechargePriorityStatus} from './types';
import {FileResponse} from './../charger-status/types';
import { useParams, Link } from 'react-router-dom';

export const RechargePriority = () => {
  const [rechargePriorityStatus, setRechargePriorityStatus] = useState<RechargePriorityStatus>();
  const [fleetVehicles, setFleetVehicles] = useState<FleetVehicle[]>();
  const [isDataReady, setIsDataReady] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [background, setBackground] = useState<string>('');
  const [logo, setLogo] = useState<string>('');

  const currentDate = moment().format('DD/MM/YYYY - HH:mm');
  
  const { id } = useParams();

  const getRechargePriorityStatusResponse = async () => {
    try {
      const response = 
      await api.get<RechargePriorityStatus>(
        `/viewer/RechargePriority/${id}`
      );
      setRechargePriorityStatus(response.data);
      setIsDataReady(true);
    } catch (error) {
      console.error(error);
    }finally {
      setIsFetching(false);
    }
  };

  const getFile = async (fileId: string) => {
    try {
      const response =
        await api.get<FileResponse>(`/Files/${String(fileId)}`);
      if (response.data) {
        setLogo(response.data.fileData);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
  }
  const getFileBg = async (fileId: string) => {
    try {
      const response =
        await api.get<FileResponse>(`/Files/${String(fileId)}`);
      if (response.data) {
        setBackground(response.data.fileData);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(()=> {
    getRechargePriorityStatusResponse();

  },[])

  useEffect(() => {
    if (rechargePriorityStatus?.csLogoFileId) {
      getFile(rechargePriorityStatus.csLogoFileId);
    }
    if (rechargePriorityStatus?.csBgFileId) {
      getFileBg(rechargePriorityStatus.csBgFileId);
    }
    if(rechargePriorityStatus) {
      setFleetVehicles(rechargePriorityStatus.fleetVehicles);
    }
  },[rechargePriorityStatus]);

  return (<Fragment>
      <div style={{ padding: '0px 16px' }}>
        <div className='rp-charger-status'>
        <HeaderViewer 
          logo={logo}
          background={background}
          bgColor={rechargePriorityStatus?.csBgColor}
          />
          {isFetching && !isDataReady ? <div className='rp-carregando'><span>Carregando...</span></div> : (
            <Fragment>
              <div className='rp-wrapper-date'>
                <img
                  src={calenderIcon}
                  alt={`${calenderIcon}`}
                  className='rp-calender-icon'
                />
                <span>{currentDate}</span>
              </div>
              <div className='rp-header-charger-status'>
                <img
                  src={chargerStationLogo}
                  alt={`${chargerStationLogo}`}
                  className='rp-charger-station-logo-image'
                />
                <p className='rp-local-title'>
                  {rechargePriorityStatus?.csName}
                </p>
              </div>
              <div className='rp-switch-cs-button-container'>
                <Link to={`/viewers/fleet/charger-status/${id}`}>
                  <button className='rp-switch-cs-button'>
                    <div className='rp-in-switch-cs-button'>
                    <span >Status Recarga</span>
                    <img className='rp-switch-button-icon' src={powerIcon} alt={`${powerIcon}`} />
                    </div>
                  </button>
                </Link>
                
              </div>
              <div className='rp-chargers-wrapper'>
                <div className='rp-chargers-header'>
                  <span className='rp-chargers-header-title'>
                    Prioridade de recarga
                  </span>
                  <div className='rp-total-chargers-wrapper'>
                    <span className='rp-total-chargers-text'>
                      Total de veículos
                    </span>
                    <span className='rp-total-number-of-chargers'>
                    {rechargePriorityStatus?.count}
                    </span>
                  </div>
                  <div className='rp-total-chargers-wrapper'>
                    <span className='rp-total-chargers-text'>
                      Demanda
                    </span>
                    <span className='rp-cp-code'>
                    {rechargePriorityStatus?.requiredBattKwh?.toFixed(0)}{' kWh'}
                    {' / '}{rechargePriorityStatus?.chargeTimeACHour ? rechargePriorityStatus?.chargeTimeACHour.toFixed(1) : '0'}{' horas'}
                    </span>
                  </div>                
                </div>
                <div className='rp-gradient' />
                <div className='rp-table-container'>
                  <table className='rp-table'>
                    <thead className='rp-table-head'>
                      <tr className='rp-table-head-tr'>
                        <th className='rp-table-head-vehicle-th rp-table-head-th'>
                          <div className='rp-th-single'>
                            <img
                              src={carIcon}
                              alt={`${carIcon}`}
                              className='rp-table-icon'
                            />
                            <span>Veículo</span>
                          </div>
                        </th>
                        <th className='rp-table-head-th'>
                          <div className='rp-th-single-power'>
                            <img
                              src={autonomyIcon}
                              alt={`${autonomyIcon}`}
                              className='rp-table-icon'
                            />
                            <span>Autonomia</span>
                          </div>
                        </th>
                        <th className='rp-table-head-th'>
                          <div className='rp-th-single-status'>
                            <img
                              src={plateIcon}
                              alt={`${plateIcon}`}
                              className='rp-table-icon'
                            />
                            <span>Placa</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className='rp-table-body'>
                      {fleetVehicles
                        ?.sort((fv1: FleetVehicle,fv2: FleetVehicle) => {
                          if(fv1.uvTelemetrySoc === null && fv2.uvTelemetrySoc === null) return 0;
                          if (fv1.uvTelemetrySoc === null) return 1;
                          if (fv2.uvTelemetrySoc === null) return -1;
                          return fv1.uvTelemetrySoc - fv2.uvTelemetrySoc;

                        })?.map((fv: FleetVehicle, i) => {

                        const brazilianTime = moment(fv.uvTelemetryTimestamp).utcOffset(-3).format('HH:mm');
                        return (
                          <tr key={i} className='rp-charger-info-tr'>
                            <td>
                              <div className='rp-charger-info'>
                                <span className='rp-charger-name'>
                                  {fv.vmName}
                                </span>
                                <span className='rp-cp-code'>
                                  Bateria: {fv.uvTelemetrySoc === null ? '-' : `${fv.uvTelemetrySoc.toFixed(0)}%`}{fv.isCharging ? <img src={powerIcon} alt={`${powerIcon}`} className='cs-table-icon' /> : ''}</span>
                              </div>
                            </td>
                            <td>
                              {fv.uvId && (
                                <div className='rp-power-info'>
                                  <span className='rp-power-kWh'>
                                    {fv.autonomyKm} Km
                                  </span>
                                  <span className='rp-power-kW'>
                                    {fv.chargeTimeAC ? fv.chargeTimeAC.substring(0, 5) : '-'}
                                  </span>
                                </div>
                              )}
                            </td>
                            <td>
                              <div className='rp-charger-status-container'>
                                <div
                                  className='rp-chager-status-wrapper'
                                  style={{ backgroundColor: fv.uvTelemetrySoc < 45 ? '#EF6D44' :
                                                            (fv.uvTelemetrySoc >= 45 && fv.uvTelemetrySoc < 65) ? '#FDE047' : '#93E22E',
                                           color: fv.uvTelemetrySoc < 45 ? '#FFFFFF' :
                                                  (fv.uvTelemetrySoc >= 45 && fv.uvTelemetrySoc < 65) ? '#713F12' : '#196912'
                                         }}
                                >
                                  <span>{fv.uvLicencePlate}</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='rp-footer'>
                <img
                  src={alertIcon}
                  alt={`${alertIcon}`}
                  className='rp-table-icon'
                />
                <div>
                  <span><strong>Problemas com o carregador,{' '}</strong>
                    Suporte por e-mail <a style={{color: 'green'}} href='mailto:suporte@spott.eco'>suporte@spott.eco</a>
                    <strong>{' '}ou por</strong> <a style={{color: 'green'}} href='https://wa.me/5511975568167'>WhatsApp</a> - (11) 97556-8167</span>
                </div>
                <Footer />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>)
}